import {
  AfterViewInit, ChangeDetectorRef,
  Component,
  Inject,
  OnChanges,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog, MatSnackBar, MatSnackBarRef} from '@angular/material';
import {State} from '@progress/kendo-data-query';
import {DOCUMENT, TitleCasePipe} from '@angular/common';
import {SwitchComponent} from '@progress/kendo-angular-inputs';
import {AgmInfoWindow, AgmMap, AgmMarker} from '@agm/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {CalendarComponent} from "@progress/kendo-angular-dateinputs";
import {EventClickEvent, SchedulerEvent} from '@progress/kendo-angular-scheduler';
import * as moment from 'moment';
import {Observable, Subject, Subscription} from 'rxjs';
import {ApiService} from '../services/api';
import {MDLinkService} from '../services/mdlink/mdlink.service';
import {UserContext} from '../services/user-context';
import {AuthService} from '../services/auth';
import {ConfirmDialogComponent} from '../shared/layout/components/confirm-dialog/confirm-dialog.component';
import {DataStateChangeEvent, GridDataResult, RowArgs, SelectionEvent} from '@progress/kendo-angular-grid';
import {FormBuilder} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-telehealth-dialog',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'telehealth-dialog.template.html',
  animations: [
    trigger('ringerState', [
      state('inactive', style({
        opacity:0
      })),
      state('active',   style({
        opacity:1
      })),
      transition('inactive => active', animate('1000ms ease-in')),
      transition('active => inactive', animate('1000ms ease-out'))
    ])
  ]
})

export class TelehealthDialogComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('onlineState', { static: true }) onlineState: SwitchComponent;
  @ViewChild('map', { static: true }) map: AgmMap;
  @ViewChild('infoWindow', { static: false }) infoWindow: AgmInfoWindow;
  @ViewChild('calendar', { static: false }) calendar: CalendarComponent;

  public crumbs: any[] = [
    {label: 'Providers', link: '/providers'}
  ];

  lat = 35.268107;
  lng = -90.744821;
  zoom = 4;

  //providerId: string;
  //provider: any;
  appointments: any[];
  dailyAppointments: any[];
  markers: any[] = [];
  online = false;
  incomingSession:any;
  messageRef:any;
  offlineDialogOpened = false;
  ringing:any;
  ringer:string = "inactive";
  infoWindowIsOpen:boolean = false;
  now = new Date();
  schedulerDate: Date = new Date();
  upcomingSessions:SchedulerEvent[];
  eventSubject:Subject<SchedulerEvent> = new Subject<SchedulerEvent>();
  events: SchedulerEvent[] = [];
  schedulerSubject:Subject<SchedulerEvent[]> = new Subject<SchedulerEvent[]>();

  // Session grid support
  public sessionView: Observable<GridDataResult>;
  public sessionSubscription: Subscription;
  public sessionState: State = {
    skip: 0,
    take: 5
  };
  public selectedAppointment: RowArgs;
  private selectedNote: RowArgs;
  awaitingAppointment:any;


  public mapStyles = [
    {elementType: 'geometry', stylers: [{color: '#aec3cb'}]},
    {elementType: 'labels.text.stroke', stylers: [{'visibility': 'off'}]},
    {elementType: 'labels.text.fill', stylers: [{color: '#888888'}]},
    {
      featureType: 'administrative.locality',
      elementType: 'labels.text.fill',
      stylers: [{color: '#555555'}]
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [{'visibility': 'off'}]
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [{color: 'transparent'}]
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text.fill',
      stylers: [{color: 'transparent'}]
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [{color: '#c0d7e0'}]
    },
    {
      featureType: 'road',
      elementType: 'geometry.stroke',
      stylers: [{color: '#bbdefb'}]
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [{color: '#9ca5b3'}]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [{color: '#c0d7e0'}]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [{color: '#c0d7e0'}]
    },
    {
      featureType: 'road.highway',
      elementType: 'labels.text.fill',
      stylers: [{color: '#81d4fa'}]
    },
    {
      featureType: 'transit',
      elementType: 'geometry',
      stylers: [{color: '#2f3948'}]
    },
    {
      featureType: 'transit.station',
      elementType: 'labels.text.fill',
      stylers: [{color: 'transparent'}]
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{color: '#e3e8ee'}]
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [{color: 'transparent'}]
    },
    {
      featureType: 'water',
      elementType: 'labels.text.stroke',
      stylers: [{color: 'transparent'}]
    }
  ];

  //private ngUnsubscribe: Subject<void> = new Subject<void>();
  //private mdlinkUnsubscribe: Subject<void> = new Subject<void>();
  private observer:any;

  constructor(     public dialogRef: MatDialogRef<TelehealthDialogComponent>,
              private cd: ChangeDetectorRef,
              public userContext: UserContext,
              public dialog: MatDialog,
              private snackBar: MatSnackBar,
              private mdlinkService: MDLinkService,
              private api: ApiService,
                    @Inject(MAT_DIALOG_DATA) public data: any) {


    this.eventSubject.subscribe(e => {
      let filteredEvents = this.events.filter(ev => ev.id !== e.id);
      filteredEvents.push(e);
      this.events = filteredEvents;
      console.log("Publishing " + this.events.length + " events...");
      this.schedulerSubject.next(this.events);

      this.updateTimeLine();

      this.cd.detectChanges();
    });

  }


  public ngOnInit(): void {

  }

  public ngOnDestroy(): void {
    //this.ngUnsubscribe.next();
    //this.ngUnsubscribe.complete();
    //this.mdlinkUnsubscribe.next();
    //this.mdlinkUnsubscribe.complete();

    this.observer.unsubscribe();
    if( this.messageRef ) {
      this.messageRef.dismiss();
    }
    this.snackBar.dismiss();
  }

  public ngAfterViewInit(): void {
    this.updateAppointments();
  }

  public sessionStateChange(state: DataStateChangeEvent): void {
    this.sessionState = state;
  }

  public updateAppointments(): void {
    this.api.get<any>(`/appointment` ).subscribe( result => {
      //console.log("Filtering appointments with " + this.userContext.user.reference + " ");
      this.appointments = (result || []).filter(a => a.user_id && a.user_id.includes(this.userContext.user.reference) && a.confirmed);
      //console.log("Adding appointments: " + JSON.stringify(this.appointments));
      (this.appointments || []).forEach( a => {
        this.eventSubject.next(<SchedulerEvent> {
          title: a.type || "Appointment",
          subject: a.subject,
          id: a.id,
          name: a.name,
          type: a.type,
          confirmed: a.confirmed,
          when: a.when,
          description: `${a.type || ""} Appointment`,
          start: moment(a.when).toDate(),
          end: moment(a.when).add(a.duration || 30, 'minutes').toDate()
        });
      });
      //this.updateAppointmentList();
    }, (error) => {
      this.snackBar.open(`Error getting appointments: ${error}`, null, {
        duration: 2000
      });
    });
  }

  public doubleClickedEvent(event: EventClickEvent) {
    if ( !this.online ) {
      this.offlineDialogOpened = true
    } else {
      this.selectedAppointment = event.event;
      this.mdlinkService.startAppointment(this.selectedAppointment.dataItem.id);
      this.awaitingAppointment = this.selectedAppointment.dataItem;
      (function smoothscroll() {
        let currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll);
          window.scrollTo(0, currentScroll - (currentScroll / 8));
        }
      })();
    }
  }

  public updateTimeLine() {
    this.upcomingSessions = this.events.filter(a => a.start > this.now).sort( (a, b) => {return b.start.toISOString().localeCompare(a.start.toISOString())}).slice(0, 5);
  }

  public onAppointmentSelection(event: SelectionEvent) {
    this.selectedAppointment = event.selectedRows[0];
  }

  public updateAppointmentList(): void {
    let selectedDate = (this.calendar ? this.calendar.focusedDate : new Date()).toISOString();
    let day = selectedDate.substring(0,10);
    //console.log("Updating appointments for " + selectedDate + " " + day );
    this.dailyAppointments = (this.appointments || []).filter((a) => { return (a.when || "").startsWith( day )});
    //console.log("Daily appointments: " + JSON.stringify(this.dailyAppointments));
  }

  public appointmentDateSelected(): void {
    this.updateAppointmentList();
  }

  public joinSession(): void {
    this.mdlinkService.startAppointment(this.selectedAppointment.dataItem.id);
    this.awaitingAppointment = this.selectedAppointment.dataItem;
    /*
    console.log("Joining session");
    const dialogRef = this.dialog.open(AppointmentDialogComponent, {
      disableClose: true,
      data: this.selectedAppointment.dataItem,
      width: '300px'
    });

    dialogRef.afterClosed().subscribe(message => {

      if(message) {
        this.handleIncomingSession(message["synchronicity"], message["session"]);
      }
    });
    */
  }

  public classesForEvent(event: any, recent: boolean) {
    let classes = ['timelineEvent'];
    classes.push(recent ? 'recent' : 'upcoming');
    if (event.type === 'diagnostic') {
      classes.push('diagnosticEvent');
    }
    if( event.type === 'telehealth') {
      classes.push('telehealthEvent');
    }
    if( event.type === 'note' || event.type === 'prescription') {
      classes.push('noteEvent');
    }
    return classes.join(" ");
  }

  public selectedTimelineEvent(event: any) {
    //console.log("Double click event: " + JSON.stringify(event.event));
    /*
    if( event.type === 'telehealth') {
      const dialogRef = this.dialog.open(SessionDialogComponent, {
        disableClose: true,
        data: event,
        width: '300px'
      });

      dialogRef.afterClosed().subscribe(message => {

        if (message) {
          this.handleIncomingSession(message["synchronicity"], message["session"]);
        }
      });
    }*/
  }

  public handlePage(consumer:any) {
    this.ringer = "active";
    if( consumer ) {
      //console.log("Pushing marker.");
      if( consumer.location && consumer.location.latitude && consumer.location.longitude ) {
        this.lat = consumer.location.latitude;
        this.lng = consumer.location.longitude;
        this.zoom = 8;
        let name = consumer.synchronicity === 'asynchronous' ? `Deferred: ${consumer.subject}` : consumer.subject;
        this.markers.push({latitude:consumer.location.latitude, longitude:consumer.location.longitude, name:name});
        this.infoWindowIsOpen = true;
        if(this.infoWindow) {
          this.infoWindow.open()
        }
      }
    }
    this.ringing = new Audio("/assets/ring.wav"); // buffers automatically when created
    this.ringing.loop = true;
    this.ringing.volume = 0.2;
    this.ringing.play();
  }

  public reset(): void {
    this.api.patchTelehealth<any>(`/request`, {action:"reset"} ).subscribe( result => {
    }, (error) => {
      this.snackBar.open(`Error resetting: ${error}`, null, {
        duration: 2000
      });
    });
  }

  public accept():void {
    this.ringer = "inactive";
    if( this.ringing ) {
      this.ringing.pause();
      this.ringing.currentTime = 0;
    }
    this.messageRef = this.snackBar.open(`Connecting...`, null)
    this.api.patchTelehealth<any>(`/request`, {action:"accept"} ).subscribe( result => {
    }, (error) => {
      this.snackBar.open(`Error accepting request: ${error}`, null, {
        duration: 2000
      });
    });
  }

  public decline():void {
    this.ringer = "inactive";
    if( this.ringing ) {
      this.ringing.pause();
      this.ringing.currentTime = 0;
    }
    this.api.patchTelehealth<any>(`/request`, {action:"decline"} ).subscribe( result => {
      this.snackBar.open(`Request declined.`, null, {
        duration: 2000
      });
    }, (error) => {
      this.snackBar.open(`Error declining request: ${error}`, null, {
        duration: 2000
      });
    });
  }

  public changeOnlineState($event):void {
    console.log("Chaning online state.");
    if(this.onlineState.checked) {
      console.log("Registering...");
      this.mdlinkService.register();
    } else {
      this.mdlinkService.reset(false);
      this.awaitingAppointment = null;
      this.selectedAppointment = null;
      if( this.ringing ) {
        this.ringing.pause();
        this.ringing.currentTime = 0;
      }
    }
  }

  /*
  public sessionStateChange(state: DataStateChangeEvent): void {
    this.sessionState = state;
    this.getSessions('');
  }

  public getSessions(search) {
    //this.loading = true;
    const page = this.sessionState.skip / this.sessionState.take + 1;
    const limit = this.sessionState.take;

    this.sessionService.getList('', '', page, limit, '', this.userContext.userInfo.sub,() => {
      //this.loading = false;
    }, search);
  }*/
/*
  public refresh(): void {
    this.api.get<any>(`/users/${encodeURIComponent(this.providerId)}`)
      .subscribe(result => {
        this.provider = result;
      }, (error) => {
        console.log('Found error ' + JSON.stringify(error));
      });
    this.getSessions('');
  }
*/

  private configurationToString(a) {
    let configuration = '';
    for ( const key in a ) {
      if (a.hasOwnProperty(key)) {
        configuration += key + ' = ' + a[key] + '; ';
      }
    }
    return configuration;
  }

  public closeOfflineDialog() {
    this.offlineDialogOpened = false;
  }


  /*
  public selectedSessionRow(event: SelectionEvent) {

    const dialogRef = this.dialog.open(SessionDialogComponent, {
      width: '650px',
      data: event.selectedRows[0].dataItem
    });

    dialogRef.afterClosed().subscribe(result => {
      if ( result ) {
        if( result.command === "update" ) {
          console.log("Updating session with " + JSON.stringify(result.object));

          this.api.patch<any>(`/sessions/${event.selectedRows[0].dataItem.id}`, result.object).subscribe(result => {
            this.getSessions(null);
            this.snackBar.open(`Updated session successfully`, null, {
              duration: 2000
            });
          }, (error) => {
            this.snackBar.open(`Error updating session: ${error}`, null, {
              duration: 2000
            });
          });
        } else if( result.command === "delete" ) {
          this.api.del<any>(`/sessions/${event.selectedRows[0].dataItem.id}`).subscribe(result => {
            console.log(JSON.stringify(result));
            this.getSessions('');
            this.snackBar.open(`Removed session successfully`, null, {
              duration: 2000
            });
          }, (error) => {
            this.snackBar.open(`Error removing session: ${error}`, null, {
              duration: 2000
            });
          });
        }
      } else {
        this.getSessions('');
      }
    });
  }*/
}
